import * as angular from 'angular';

"use strict";
angular.module('DateService', []);

export default 'DateService'
